(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["legynd-about-non-negotiables"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindExclusive = (root) => {
      if (!root || root.dataset.nnBound === 'true') return;
      root.dataset.nnBound = 'true';
      root.addEventListener('toggle', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLDetailsElement) || !target.open) return;
        if (!target.classList.contains('legynd-about-nn__item')) return;
        root.querySelectorAll('details.legynd-about-nn__item[open]').forEach((item) => {
          if (item !== target) item.open = false;
        });
      });
    };

    const init = () => {
      document.querySelectorAll('.legynd-about-nn__list').forEach(bindExclusive);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legynd-about-team"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const setFlipped = (card, flipped) => {
      card.classList.toggle('is-flipped', flipped);

      const openBtn = card.querySelector('[data-legynd-team-open]');
      const closeBtn = card.querySelector('[data-legynd-team-close]');
      const back = card.querySelector('.legynd-about-team__face--back');

      if (openBtn) {
        openBtn.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        openBtn.tabIndex = flipped ? -1 : 0;
      }
      if (closeBtn) {
        closeBtn.setAttribute('aria-expanded', flipped ? 'true' : 'false');
        closeBtn.tabIndex = flipped ? 0 : -1;
      }
      if (back) {
        back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
      }

      if (flipped && closeBtn) {
        closeBtn.focus({ preventScroll: true });
      } else if (!flipped && openBtn) {
        openBtn.focus({ preventScroll: true });
      }
    };

    const bindCard = (card) => {
      if (!card || card.dataset.bound === 'true') return;
      card.dataset.bound = 'true';

      card.querySelector('[data-legynd-team-open]')?.addEventListener('click', () => {
        setFlipped(card, true);
      });

      card.querySelector('[data-legynd-team-close]')?.addEventListener('click', () => {
        setFlipped(card, false);
      });

      card.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && card.classList.contains('is-flipped')) {
          setFlipped(card, false);
        }
      });
    };

    const init = () => {
      document.querySelectorAll('[data-legynd-team-card]').forEach(bindCard);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legynd-anatomy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE_MQ = '(max-width: 749px)';

    const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

    const closeHotspot = (hotspot, { restoreFocus = false } = {}) => {
      if (!hotspot) return;
      const trigger = hotspot.querySelector('[data-legynd-hotspot-trigger]');
      const panel = hotspot.querySelector('[data-legynd-hotspot-panel]');
      hotspot.classList.remove('is-active');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.removeAttribute('aria-current');
      }
      if (panel) panel.hidden = true;
      if (restoreFocus && trigger) trigger.focus();
    };

    const closeAll = (section, { except = null, restoreFocus = false } = {}) => {
      section.querySelectorAll('[data-legynd-hotspot]').forEach((item) => {
        if (except && item === except) return;
        const wasActive = item.classList.contains('is-active');
        closeHotspot(item, { restoreFocus: restoreFocus && wasActive });
      });
    };

    const setActiveCard = (section, hotspotId) => {
      section.querySelectorAll('.legynd-anatomy__card[data-hotspot-id]').forEach((card) => {
        const isActive = card.getAttribute('data-hotspot-id') === hotspotId;
        card.classList.toggle('is-active', isActive);
        if (isActive) {
          card.setAttribute('aria-current', 'true');
        } else {
          card.removeAttribute('aria-current');
        }
      });
    };

    const scrollCardIntoView = (section, hotspotId, { smooth = true } = {}) => {
      const track = section.querySelector('[data-legynd-anatomy-cards]');
      const card = section.querySelector(`.legynd-anatomy__card[data-hotspot-id="${hotspotId}"]`);
      if (!track || !card) return;

      // Ignore scroll-driven hotspot sync while we move the track ourselves
      track.dataset.legyndScrollLock = 'true';
      if (track._legyndScrollUnlock) window.clearTimeout(track._legyndScrollUnlock);

      const left =
        card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      track.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' });

      const unlock = () => {
        track.dataset.legyndScrollLock = 'false';
        track._legyndScrollUnlock = null;
      };

      if (smooth) {
        track._legyndScrollUnlock = window.setTimeout(unlock, 450);
      } else {
        window.requestAnimationFrame(unlock);
      }
    };

    const activateHotspot = (section, hotspot, { moveFocus = false, scrollCard = true } = {}) => {
      const trigger = hotspot.querySelector('[data-legynd-hotspot-trigger]');
      const panel = hotspot.querySelector('[data-legynd-hotspot-panel]');
      const closeBtn = hotspot.querySelector('[data-legynd-hotspot-close]');
      const hotspotId = hotspot.getAttribute('data-hotspot-id');
      const mobile = isMobile();

      closeAll(section);
      hotspot.classList.add('is-active');

      if (trigger) {
        if (mobile) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-current', 'true');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          trigger.removeAttribute('aria-current');
        }
      }

      if (panel) {
        if (mobile) {
          panel.hidden = true;
        } else {
          panel.hidden = false;
          if (moveFocus) (closeBtn || panel).focus();
        }
      }

      if (hotspotId) {
        setActiveCard(section, hotspotId);
        if (mobile && scrollCard) scrollCardIntoView(section, hotspotId);
        const track = section.querySelector('[data-legynd-anatomy-cards]');
        track?.dispatchEvent(new Event('legynd:carousel:sync'));
      }
    };

    const hotspotFromCardScroll = (section) => {
      const track = section.querySelector('[data-legynd-anatomy-cards]');
      if (!track) return null;
      const cards = [...track.querySelectorAll('.legynd-anatomy__card[data-hotspot-id]')];
      if (!cards.length) return null;

      const trackLeft = track.scrollLeft;
      let closest = cards[0];
      let closestDist = Infinity;

      cards.forEach((card) => {
        const dist = Math.abs(card.offsetLeft - trackLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = card;
        }
      });

      const id = closest.getAttribute('data-hotspot-id');
      return section.querySelector(`[data-legynd-hotspot][data-hotspot-id="${id}"]`);
    };

    document.querySelectorAll('[data-legynd-anatomy]').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const initiallyOpen = section.querySelectorAll('[data-legynd-hotspot].is-active');
      initiallyOpen.forEach((item, index) => {
        if (index > 0) closeHotspot(item);
      });

      const active = section.querySelector('[data-legynd-hotspot].is-active');
      if (active) {
        const id = active.getAttribute('data-hotspot-id');
        if (id) setActiveCard(section, id);
        if (isMobile()) {
          const panel = active.querySelector('[data-legynd-hotspot-panel]');
          if (panel) panel.hidden = true;
          const trigger = active.querySelector('[data-legynd-hotspot-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.setAttribute('aria-current', 'true');
          }
          if (id) {
            window.requestAnimationFrame(() => {
              scrollCardIntoView(section, id, { smooth: false });
            });
          }
        }
      }

      section.addEventListener('click', (event) => {
        const closeBtn = event.target.closest('[data-legynd-hotspot-close]');
        if (closeBtn) {
          if (isMobile()) return;
          const hotspot = closeBtn.closest('[data-legynd-hotspot]');
          closeHotspot(hotspot, { restoreFocus: true });
          return;
        }

        const trigger = event.target.closest('[data-legynd-hotspot-trigger]');
        if (!trigger || !section.contains(trigger)) return;

        const hotspot = trigger.closest('[data-legynd-hotspot]');
        const wasActive = hotspot.classList.contains('is-active');
        const mobile = isMobile();

        if (mobile) {
          activateHotspot(section, hotspot, { scrollCard: true });
          return;
        }

        closeAll(section);

        if (!wasActive) {
          activateHotspot(section, hotspot, { moveFocus: event.detail === 0, scrollCard: false });
        } else {
          trigger.focus();
        }
      });

      section.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || isMobile()) return;
        const activeHotspot = section.querySelector('[data-legynd-hotspot].is-active');
        if (!activeHotspot) return;
        event.preventDefault();
        closeHotspot(activeHotspot, { restoreFocus: true });
      });

      document.addEventListener('click', (event) => {
        if (isMobile()) return;
        if (!section.querySelector('[data-legynd-hotspot].is-active')) return;
        if (event.target.closest('[data-legynd-hotspot]')) return;
        closeAll(section);
      });

      const track = section.querySelector('[data-legynd-anatomy-cards]');
      if (track) {
        track.addEventListener('legynd:carousel:select', (event) => {
          const id = event.detail?.id;
          if (!id) return;
          const hotspot = section.querySelector(`[data-legynd-hotspot][data-hotspot-id="${id}"]`);
          if (!hotspot) return;
          activateHotspot(section, hotspot, { scrollCard: true });
        });

        let scrollTick = false;
        track.addEventListener(
          'scroll',
          () => {
            if (!isMobile() || scrollTick) return;
            if (track.dataset.legyndScrollLock === 'true') return;
            scrollTick = true;
            window.requestAnimationFrame(() => {
              scrollTick = false;
              if (track.dataset.legyndScrollLock === 'true') return;
              const hotspot = hotspotFromCardScroll(section);
              if (!hotspot || hotspot.classList.contains('is-active')) return;
              activateHotspot(section, hotspot, { scrollCard: false });
            });
          },
          { passive: true }
        );

        track.dispatchEvent(new Event('legynd:carousel:sync'));
      }

      window.matchMedia(MOBILE_MQ).addEventListener('change', (event) => {
        const current = section.querySelector('[data-legynd-hotspot].is-active');
        if (!current) return;
        if (event.matches) {
          activateHotspot(section, current, { scrollCard: true });
        } else {
          activateHotspot(section, current, { scrollCard: false });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legynd-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-legynd-comparison]').forEach((section) => {
      if (section.dataset.bound === 'true') return;
      section.dataset.bound = 'true';

      const expandLabel = section.dataset.expandLabel || 'Show more specifications';
      const collapseLabel = section.dataset.collapseLabel || 'Show fewer specifications';

      section.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-compare-group]');
        if (tab && section.contains(tab)) {
          const group = tab.getAttribute('data-compare-group');
          section.querySelectorAll('[data-compare-group]').forEach((btn) => {
            const active = btn === tab;
            btn.classList.toggle('is-active', active);
            btn.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          section.querySelectorAll('[data-compare-panel]').forEach((panel) => {
            const active = panel.getAttribute('data-compare-panel') === group;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
          return;
        }

        const expandBtn = event.target.closest('[data-legynd-compare-expand]');
        if (!expandBtn || !section.contains(expandBtn)) return;

        const panel = expandBtn.closest('[data-compare-panel]');
        if (!panel) return;

        const expanded = expandBtn.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;
        expandBtn.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');

        const label = expandBtn.querySelector('[data-expand-text]');
        if (label) label.textContent = nextExpanded ? collapseLabel : expandLabel;

        panel.querySelectorAll('[data-spec-collapsible]').forEach((row) => {
          row.hidden = !nextExpanded;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legynd-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindForm = (form) => {
      if (!form || form.dataset.legyndContactBound === 'true') return;
      form.dataset.legyndContactBound = 'true';
      form.addEventListener('submit', () => {
        const first = form.querySelector('[data-contact-first]');
        const last = form.querySelector('[data-contact-last]');
        const name = form.querySelector('[data-contact-name]');
        if (!name) return;
        const parts = [];
        if (first && first.value.trim()) parts.push(first.value.trim());
        if (last && last.value.trim()) parts.push(last.value.trim());
        name.value = parts.join(' ');
      });
    };

    const openInbox = () => {
      const selectors = [
        '#shopify-chat',
        'button.chat-toggle',
        'button[aria-label*="chat" i]',
        'iframe#dummy-chat-button-iframe',
      ];
      for (const selector of selectors) {
        const node = document.querySelector(selector);
        if (node) {
          node.click();
          return;
        }
      }
    };

    const bindChat = (button) => {
      if (!button || button.dataset.legyndChatBound === 'true') return;
      button.dataset.legyndChatBound = 'true';
      button.addEventListener('click', openInbox);
    };

    const init = () => {
      document.querySelectorAll('.legynd-contact__form').forEach(bindForm);
      document.querySelectorAll('[data-legynd-chat-trigger]').forEach(bindChat);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
